export class ProductFixed {
	private element: HTMLElement;
	private readonly infoBlock: HTMLButtonElement = document.querySelector('.product-info');
	private readonly activeClass: string = 'product-fixed--active';

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private handleScroll = (): void => {
		if (this.infoBlock.getBoundingClientRect().bottom < 44) this.element.classList.add(this.activeClass);
		else this.element.classList.remove(this.activeClass);
	};

	public init = (): void => {
		window.addEventListener('scroll', this.handleScroll);
	};
}
